import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationOidcService } from '../../services/authentication-oidc-service';
import { FromProviderType } from '../../interfaces/from-type-enum';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.html',
  styleUrls: ['./unauthorized.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class UnauthorizedComponent {
  providerName: string = '';
  platformUrl: string = '';
  private providerType: string | null = null;

  constructor(
    private readonly authenticationOidcService: AuthenticationOidcService,
    private readonly router: Router
  ) {
    this.providerType = sessionStorage.getItem(environment.PROVIDER_TYPE_STORAGE_KEY);
    
    switch (this.providerType) {
      case FromProviderType.IMPERIA:
        this.providerName = 'Imperia';
        this.platformUrl = environment.IMPERIA_SITE_URI;
        break;
      case FromProviderType.SUITEEDGE:
        this.providerName = 'Suite Edge';
        this.platformUrl = environment.B2C_SITE_URI;
        break;
      default:
        this.providerName = 'Imperia or Suite Edge';
        this.platformUrl = '';
        break;
    }

    // Clear any existing session if user is somehow still logged in
    if (this.authenticationOidcService.isLoggedIn) {
      console.log('🧹 Clearing existing session');
      this.authenticationOidcService.logout();
    }
  }

  /**
   * Redirect user back to the platform they came from
   */
  returnToPlatform(): void {
    if (this.platformUrl) {
      console.log('🔙 Redirecting to platform:', this.platformUrl);
      window.location.href = this.platformUrl;
    }
  }

  /**
   * Try to reconnect by initiating login flow again
   */
  tryReconnect(): void {
    if (this.providerType) {
      console.log('🔄 Attempting to reconnect with provider:', this.providerType);
      this.authenticationOidcService.login(this.providerType as FromProviderType);
    } else {
      console.warn('⚠️ No provider type found, redirecting to home');
      this.router.navigate(['/']);
    }
  }
}
